export default __webpack_public_path__ + "c84b161a4ba51be53410d0980daa8311.jpg";